var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Toggle from '@web/components/layout/Toggle/Toggle';
import { Tooltip } from '@web/components/ui/Tooltip';
import { IS_DEMO } from '@web/config';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { toast } from '@web/hocs/useToast';
import { trpc } from '@web/lib/trpc';
import { createSettingsToasts } from '@web/utility/toastUtils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
var ToggleActiveUser = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var user = _a.user, currentUser = _a.currentUser, refetch = _a.refetch, usersActiveCount = _a.usersActiveCount;
    var t = useTranslation().t;
    var userCtxRefetch = useWorkspaceCtx().userCtxRefetch;
    var updateUserStatus = trpc.updateUser.useMutation();
    var showStatusUpdatedToast = createSettingsToasts(toast, t).showStatusUpdatedToast;
    var _h = useState({}), demoToggleState = _h[0], setDemoToggleState = _h[1];
    var handleToggleChange = function (user) {
        var isDisabledSelf = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === user.id;
        if (isDisabledSelf) {
            toast({
                title: t('usersSection.cannotDisableSelf'),
                variant: 'error',
                duration: 3000
            });
            return;
        }
        if (IS_DEMO) {
            setDemoToggleState(function (prev) {
                var _a;
                var _b;
                return (__assign(__assign({}, prev), (_a = {}, _a[user.id] = !((_b = prev[user.id]) !== null && _b !== void 0 ? _b : user.isActive), _a)));
            });
            showStatusUpdatedToast();
            return;
        }
        updateUserStatus.mutate({
            userId: user.id,
            isActive: !user.isActive
        }, {
            onSuccess: function () {
                refetch();
                showStatusUpdatedToast();
                userCtxRefetch();
            }
        });
    };
    var maxUsers = (_c = (_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.workspace) === null || _b === void 0 ? void 0 : _b.subscription) === null || _c === void 0 ? void 0 : _c.maxUsers;
    var isOverLimit = maxUsers || maxUsers === 0
        ? usersActiveCount >=
            ((_f = (_e = (_d = currentUser === null || currentUser === void 0 ? void 0 : currentUser.workspace) === null || _d === void 0 ? void 0 : _d.subscription) === null || _e === void 0 ? void 0 : _e.maxUsers) !== null && _f !== void 0 ? _f : 0)
        : false;
    var enabledState = IS_DEMO
        ? ((_g = demoToggleState[user.id]) !== null && _g !== void 0 ? _g : user.isActive)
        : user.isActive;
    if (!user.isActiveOnGoogle) {
        return (_jsx(Tooltip, __assign({ content: t('usersSection.toggleStatus.disabled') }, { children: _jsx("div", { children: _jsx(Toggle, { enabled: enabledState, disabled: !IS_DEMO, onChange: function () { return handleToggleChange(user); } }) }) })));
    }
    if (isOverLimit && !enabledState) {
        return (_jsx(Tooltip, __assign({ content: t('usersSection.toggleStatus.overLimit') }, { children: _jsx("div", { children: _jsx(Toggle, { enabled: enabledState, disabled: !IS_DEMO, onChange: function () { return handleToggleChange(user); } }) }) })));
    }
    return (_jsx(Toggle, { onChange: function () { return handleToggleChange(user); }, enabled: enabledState }));
};
export default ToggleActiveUser;
